<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
// Custom function Navigation mega menu by DeanNguyen - Begin 
function changeCollectionImage(ele, imageUrl) {
    document.getElementById(ele).src = imageUrl;
    document.getElementById(ele).srcset = imageUrl;
}
function changeCollectionText(ele, colText) {
    document.getElementById(ele).innerText = colText;
}
window.addEventListener("load", () => {
    const masonryGridItems = document.querySelectorAll(".masonry-item .site-nav");
  
    masonryGridItems.forEach((item, index) => {
        if (index % 2 !== 0) {
        const prevItem = masonryGridItems[index - 1];
        item.style.height = `${prevItem.offsetHeight}px`;
        }
    });
});
// Custom function Navigation mega menu by DeanNguyen - end

// Custom function preorder for Rebuy by DeanNguyen - Begin 
function isBackorder(productTags, chkTag ="was_instock"){
    return productTags.includes(chkTag);
};

function getCustomAttr(customAttributes, attr_name) {
    return (customAttributes || []).find(attr => attr.name === attr_name)?.value;
}

function buttonLabelHDX(product){
    if (!product) return;
    let buttonLabel = "";
    const pv = product.selected_variant;
    const inv_man = pv.inventory_management ?? getCustomAttr(pv.customAttributes,'inventory_management');
    if(inv_man ){
        const inv_qty = pv.inventory_quantity ?? getCustomAttr(pv.customAttributes,'inventory_quantity');

        if(inv_qty > 0){
            buttonLabel = window.variantStrings.addToCart;
        }else{
            const inv_plc = pv.inventory_policy ?? getCustomAttr(pv.customAttributes,'inventory_policy');

            if (inv_plc == "continue") {
                if(isBackorder(product.tags)){
                    buttonLabel = "Back Order";
                }else{
                    buttonLabel = window.variantStrings.preOrder;
                }
            }else{
                buttonLabel = window.inventory_text.outOfStock;
            }
        }
    }else{
        buttonLabel = window.inventory_text.manyInStock;
    }
    return buttonLabel;
};

function getETA(product){
    let text = "";
    if (!product) return '';
    const pv = product.selected_variant;
    if(pv.inventory_management ){
        if(pv.inventory_quantity <= 0){
            
            if (pv.inventory_policy == "continue") {
                if (product.metafields.custom && product.metafields.custom.arrival_date != null) {
                    const arrivalDate = new Date(product.metafields.custom.arrival_date);
                    const currentDate = new Date();
                    const differenceInDays = Math.ceil((arrivalDate - currentDate) / (1000 * 60 * 60 * 24)); // Chênh lệch ngày

                    // Lấy tháng viết tắt (VD: "Dec")
                    const monthShort = arrivalDate.toLocaleString("default", { month: "short" });
                    const month = String(arrivalDate.getMonth() + 1).padStart(2, "0");
                    const day = String(arrivalDate.getDate()).padStart(2, "0");
                    const year = arrivalDate.getFullYear(); 
                    

                    if (differenceInDays > 21) {
                        if (day >= 1 && day <= 10) {
                            text = `Early In ${monthShort}`;
                        } else if (day >= 11 && day <= 20) {
                            text = `Mid Of ${monthShort}`;
                        } else {
                            text = `End Of ${monthShort}`;
                        }
                    } else if (differenceInDays > 0 ) {
                        text = `ETA: ${month}/${day}/${year}`;
                    }
                    if (text != ''){
                        text = '<div class="product_eta"><div class="text_eta">'+text+'</div></div>';
                        //console.log(pv.sku);
                    }
                }
            }
        }
    }
    return text;
}

function getBadge(product){
    let text = "";
    if (!product) return '';
    
    const pv = product.selected_variant;
    
    const com_price = parseFloat(pv.compare_at_price ?? pv.compareAtPrice);
    const sale_price = parseFloat(pv.price) ;
    
    if (com_price > sale_price){
        const discountPercentage = Math.round(((com_price - sale_price) / com_price) * 100);
        text ='<span class="badge sale-badge" aria-hidden="true">Sale '+discountPercentage+'%</span>';
        
    }
    // if( pv.sku == "RER31319"){
    //     console.log(com_price , sale_price , text);
    // }
    let soldText = 'In Stock';
    let soldClass = 'In-Stock';
    
    const inv_man = pv.inventory_management ?? getCustomAttr(pv.customAttributes,'inventory_management');
    if(inv_man ){
        const inv_qty = pv.inventory_quantity ?? getCustomAttr(pv.customAttributes,'inventory_quantity');
        if(inv_qty <= 0){
            const inv_plc = pv.inventory_policy ?? getCustomAttr(pv.customAttributes,'inventory_policy');
            if (inv_plc == "continue") {
                if(isBackorder(product.tags)){
                    soldText = 'Back Order';
                    soldClass = 'Back-Order';

                }else{
                    soldText = window.variantStrings.preOrder;
                    soldClass = 'Pre-Order';
                    
                }
            }else{
                soldText = window.variantStrings.soldOut;
                soldClass = 'Sold-Out';
            }
        }
    }
    text +='<span class="badge sold-out-badge ' + soldClass + '" aria-hidden="true">'+soldText+'</span>';
   
    return text;
}


(function ($) {
    var $body = $('body'),
        $doc = $(document),
        $html = $('html'),
        $win = $(window),
        sliderNavHTML;
    $doc.ready(() => {
        document.addEventListener('rebuy.ready', function(event){ 
            if (Rebuy && Rebuy.SmartSearch) {
                // Custom lại số cột sản phẩm theo viewpoint 
                Rebuy.SmartSearch.getProductsPerColumn = function () {
                    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                    // Trả về giá trị dựa trên điều kiện
                    if (viewportWidth <= 390) return 1;
                    if (viewportWidth <= 480) return 2;
                    if (viewportWidth <= 768) return 3;
                    if (viewportWidth <= 1024) return 4;
                    return 4; // Mặc định
                };
                // Thiết lập giá trị khởi đầu cho search term khi open 
                document.addEventListener('rebuy:smartsearch.quickview.open', (event) => {
                    Rebuy.SmartSearch.quickView.view.searchTerm = $('#Search-In-Modal-Single').val();
                });
                // Gán giá trị search term vào input sau khi đóng quick view search
                document.addEventListener('rebuy:smartsearch.quickview.close', (event) => {
                    $('#Search-In-Modal-Single').val(Rebuy.SmartSearch.quickView.view.searchTerm);               
                });

                document.addEventListener('rebuy:smartsearch.resultsPage.productsChange', (event) => {
                    const filterSettings = event.detail.smartSearchResultsPage.settings.searchResultsSettings.setting.filterSettings;
                    filterSettings.forEach(element => {
                        element.isExpanded = true;
                    });
                    
                });
            }
            if (window.Rebuy && Array.isArray(Rebuy.widgets)) {
                Rebuy.widgets.forEach(widget => {
                    const widgetId = widget.id;

                    // Tìm wrapper tương ứng widgetId
                    const wrapper = document.querySelector(`.rebuy-widget-wrapper[data-rebuy-wrapper-id="${widgetId}"]`);
                    if (wrapper) {
                        const skeleton = wrapper.querySelector('.rebuy-skeleton-grid');
                        const container = wrapper.querySelector('.rebuy-widget-container');

                        // Nếu widget đã render sẵn, xử lý ngay
                        if (container) {
                            skeleton?.remove();
                            container.classList.remove('opacity-0');
                            const observer = new MutationObserver((mutationsList, observer) => {
                                if (container.querySelector('.rebuy-product-grid')) {
                                    observer.disconnect();
                                    
                                    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
                                }
                            });
                            observer.observe(container, { childList: true, subtree: true });
                        }

                        // Nếu widget đã render sẵn, xử lý ngay
                        // if (container) {
                        //     skeleton?.remove();
                        //     container.classList.remove('opacity-0');
                        // }
                    }
                });
            }
        }); 
        
    });  
    
})(jQuery);


  
// Custom function preorder for Rebuy by DeanNguyen - Begin 
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
